import { Link } from "react-router-dom";
import { brand } from "@mbb/config";
import Sunburst from "../../components/Sunburst";
import Scallop from "../../components/Scallop";

export default function Hero() {
  return (
    <section
      style={{
        position: "relative",
        background: "var(--c-blush)",
        overflow: "hidden",
        paddingBlock: "clamp(5rem, 12vw, 9rem) clamp(3rem, 8vw, 6rem)",
        isolation: "isolate",
      }}
    >
      {/* sunburst — bleeds off the right edge */}
      <Sunburst
        size="min(110vw, 1100px)"
        color="var(--c-coral)"
        rays={48}
        style={{
          position: "absolute",
          top: "-22%",
          right: "-28%",
          opacity: 0.35,
          zIndex: -1,
        }}
      />
      {/* second, smaller sunburst — bottom-left */}
      <Sunburst
        size="380px"
        color="var(--c-brass)"
        rays={28}
        style={{
          position: "absolute",
          bottom: "-12%",
          left: "-8%",
          opacity: 0.3,
          zIndex: -1,
        }}
      />

      <div className="container">
        <div className="eyebrow" style={{ color: "var(--c-palm)" }}>
          A book club for the 209 · est. {brand.established}
        </div>
        <h1
          className="display display--xl"
          style={{
            marginTop: "1rem",
            marginBottom: "1.25rem",
            maxWidth: "16ch",
          }}
        >
          read together,
          <br />
          stay <em style={{ color: "var(--c-coral)" }}>besties.</em>
        </h1>
        <p
          className="lead"
          style={{
            color: "var(--c-palm)",
            opacity: 0.92,
            marginBottom: "2.25rem",
            maxWidth: "44ch",
          }}
        >
          Manteca Book Besties is a small, kind, women-led book club in Manteca.
          One book a month. Real talk. Iced drinks by the pool. {brand.membershipPriceLabel}.
        </p>
        <div style={{ display: "flex", gap: "0.85rem", flexWrap: "wrap" }}>
          <Link to="/apply" className="btn btn--primary">
            Apply now
          </Link>
          <a href="#about" className="btn btn--ghost">
            What's this about?
          </a>
        </div>
      </div>

      <Scallop
        color="var(--c-sand)"
        height={36}
        style={{ position: "absolute", left: 0, right: 0, bottom: 0 }}
      />
    </section>
  );
}
